import React from 'react';

const RightArea: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <div className="right-area">{children}</div>;
};

export default RightArea;
